export default __webpack_public_path__ + "static/backgroundPublisher-357967be88b5e34d942ef252a93ab94b.jpg";